export class ViewingSessionModel{
    viewingSessionId:string;
    constructor(){}
 }


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/docviewer/viewingsession.model.ts